<template>
  <div class="flex flex-col w-full" v-if="user">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),
  },

};
</script>

<style lang="scss" scoped>
  svg:hover {
    fill: forestgreen;
  }
</style>
